import React from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
function CableCutting() {
  const clients = [
    {
      img: "/assets/services/emc-protection.svg",
      title: "EMC (Electromagnetic Compatibility) Protection",
      text: "EMC protection ensures that electrical and electronic devices operate without interference from or to other equipment. Our enclosures are designed with shielding and grounding provisions to minimize electromagnetic disturbances, making them ideal for sensitive control and communication systems.",
      link: "/services/emc-protection"
    },
    {
      img: "/assets/services/socket-combination-boxes.svg",
      title: "Socket Combination Boxes",
      text: "These are customizable power distribution units that combine multiple socket outlets in a single enclosure. Commonly used on industrial sites, they offer flexible, safe, and organized power access for machines, tools, and temporary setups.",
      link: "/services/socket-combination-boxes"
    },
    {
      img: "/assets/services/wiring-installation.svg",
      title: "Wiring & Installation",
      text: "We provide complete internal wiring and component installation within the enclosures as per the client’s specifications. This includes routing, terminating, and testing all electrical connections for a ready-to-use solution, reducing on-site work and installation time.",
      link: "/services/wiring-installation"
    },
    {
      img: "/assets/services/emergency-push-button.svg",
      title: "Emergency Push Button",
      text: "Designed for safety-critical applications, these buttons allow users to immediately shut down equipment or stop processes during emergencies. Enclosed in rugged housings, they are easily accessible, clearly marked, and compliant with safety standards.",
      link: "/services/emergency-push-button"
    },
    {
      img: "/assets/services/terminal-junction-boxes.svg",
      title: "Terminal Junction Boxes",
      text: "These boxes provide a secure and organized environment for connecting, branching, and protecting electrical wires. They simplify cable management and troubleshooting while offering protection from dust, moisture, and mechanical stress.",
      link: "/services/terminal-junction-boxes"
    },
    {
      img: "/assets/services/control-stations.svg",
      title: "Control Stations",
      text: "Control stations house switches, indicators, and operator controls in a compact and durable enclosure. They are used to manage and monitor machines or processes, and can be customized based on operational needs — including single or multiple controls.",
      link: "/services/control-stations"
    },
    {
      img: "/assets/services/push-button-stations.svg",
      title: "Push Button Stations",
      text: "These are enclosures equipped with one or more push buttons to start, stop, or control specific functions of machinery or systems. They are built to withstand industrial conditions and can include features like illuminated indicators or labels for easy identification.",
      link: "/services/push-button-stations"
    }
  ];

  return (
    <>
    <Helmet>
    <title>
        Cable Cutting, Harnessing & Labelling Services UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides professional cable cutting, harnessing, labelling and assembly services in the UAE. Pre-cut and labelled cables are packed with customer-specific identification for faster installation, traceability and reduced project waste."
    />

    <meta
        name="keywords"
        content="cable cutting services UAE, cable harnessing UAE, cable labelling UAE, cable assembly services UAE, pre-cut cables UAE, labelled cables UAE, cable preparation UAE, cable identification UAE, electrical cable assembly UAE, cable management services UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/cable-cutting"
    />

    <meta
        property="og:title"
        content="Cable Cutting, Harnessing & Labelling Services UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Pre-cutting, labelling and cable assembly services designed for faster installation, full traceability, reduced waste and ready-to-use cable delivery."
    />

    <meta
        property="og:url"
        content="https://saig.me/cable-cutting"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
      <div className='newbanner-about newbanner-about2'>
        <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
          <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cable Cutting, Harnessing, Labelling & Assemblies</h6>
          {/* <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Industrial Labeling & Tagging Solutions */}
          {/* </p> */}
        </div>
      </div>
         <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Cable Cutting, Harnessing, Labelling & Assemblies</h2>
  <div className='line'></div>
                         <h3 className='text-justify'>Our pre-cutting and labelling services ensure that the cables are neatly cut and labelled with
appropriate tags. The customer orders are then protected and packed with customer specific
labelling to ensure full traceability. </h3>

               </div>
               </div>
      <div className='service-details-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[50px]'>
        <div className='service-details-div-left'>
          <img src='/assets/newsr4.png' />
        </div>
        <div className='service-details-div-right font-kanit'>
<ul className="mt-4 grid grid-cols-1 md:grid-cols-1 ">
  {[
    "Readiness to use upon arrival of the cables at the site",
    "Elimination the need of contingency ordering",
    "Faster installation",
    "Elimination of waste and disposal",
    "Eliminates the need of heavy lifting equipment’s",
    "Achieves a cost reduction in totality",
   
  ].map((item, i) => (
    <li
      key={i}
      className="flex items-start gap-3 rounded-lg bg-white px-4  transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed aplus">
        {item}
      </span>
    </li>
  ))}
</ul>
          <Link to='/services'>

            <button className='backbtn'>
              Back To Services
            </button>
</Link>
        </div>
      </div>
      {/* <div className='service-details-div2 font-kanit max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] mb-[40px]'>
        <div className='grid lg:grid-cols-2 grid-cols-1 gap-[30px]'>

          <div className='ser-box'>


            <h4>EMC (Electromagnetic Compatibility) Protection</h4>

            <p>EMC protection ensures that electrical and electronic devices operate without interference from or to other equipment. Our enclosures are designed with shielding and grounding provisions to minimize electromagnetic disturbances, making them ideal for sensitive control and communication systems.</p>
          </div>
          <div className='ser-box'>

            <h4>Socket Combination Boxes</h4>

            <p>These are customizable power distribution units that combine multiple socket outlets in a single enclosure. Commonly used on industrial sites, they offer flexible, safe, and organized power access for machines, tools, and temporary setups.</p>
          </div>
          <div className='ser-box'>

            <h4>Wiring & Installation</h4>


            <p>We provide complete internal wiring and component installation within the enclosures as per the client’s specifications. This includes routing, terminating, and testing all electrical connections for a ready-to-use solution, reducing on-site work and installation time.</p>
          </div>

          <div className='ser-box'>

            <h4>Emergency Push Button</h4>
            <p>Designed for safety-critical applications, these buttons allow users to immediately shut down equipment or stop processes during emergencies. Enclosed in rugged housings, they are easily accessible, clearly marked, and compliant with safety standards.</p>
          </div>
          <div className='ser-box'>

            <h4>Terminal Junction Boxes</h4>
            <p>These boxes provide a secure and organized environment for connecting, branching, and protecting electrical wires. They simplify cable management and troubleshooting while offering protection from dust, moisture, and mechanical stress.</p>
          </div>
          <div className='ser-box'>

            <h4>Control Stations</h4>
            <p>Control stations house switches, indicators, and operator controls in a compact and durable enclosure. They are used to manage and monitor machines or processes, and can be customized based on operational needs — including single or multiple controls.

            </p>
          </div>

          <div className='ser-box'>

            <h4>Push Button Stations</h4>
            <p>These are enclosures equipped with one or more push buttons to start, stop, or control specific functions of machinery or systems. They are built to withstand industrial conditions and can include features like illuminated indicators or labels for easy identification.
            </p>
          </div>

        </div>
      </div> */}

      {/* 
       <section className="bg-[#fff] dark:bg-[#FBB210] py-[60px] md:py-[50px]">
                <div className="max-w-[1200px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[12px] px-[20px]">
                    <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000] dark:text-[#000000] lg:sticky lg:top-[150px] self-start">
                        <h6 data-aos="fade-right" className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]">
                            Product & Service List with Descriptions
                        </h6>
                        <p className="font-outfit text-[16px] font-[400] leading-[24px] mb-[20px] md:mb-[36px]">
                            Trusted Solutions. Tailored Excellence.
At Al Ibtekar, we go beyond... across industrial, automation, solar and oil & gas sectors
                        </p>
                        <div className="group inline-flex items-center cursor-pointer">
                            <i className="bi bi-arrow-right text-[#fff] text-[40px] transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                        </div>

                    </div>
                    <div className="lg:max-w-[600px] max-w-[100%] w-full">
                        <div className="grid gap-[20px]">
                            {clients.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="nsr border group relative rounded-[8px]  backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] transition-transform duration-300 transform hover:scale-[1.03] hover:shadow-lg"
                                        style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                                    >
                                        <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start">
                                          
                                            <div className='text-[#000] dark:text-[#000000]'>
                                                <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500] mb-[15px] md:mb-[25px] dark:text-[#000] dark:group-hover:text-white">                                                    {item.title}
                                                </h6>
                                                <p className="text-[14px] font-outfit font-[400] leading-[20px] dark:text-[#000] dark:group-hover:text-white">
                                                    {item.text}
                                                </p>
                                           <Link
    to={item.link}
    className="text-left font-outfit text-[14px] font-[700] leading-[20px] mt-[15px] md:mt-[20px] flex sm:justify-start text-[#FFFFFF] hover:underline group"
>
    <p className="transition-all duration-300 dark:text-[#000] dark:group-hover:text-white">
        Read more
    </p>
</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}
    </>
  )
}

export default CableCutting